export const FETCHING_USERS_DOSSIERS = 'FETCHING_USERS_DOSSIERS';
export const FETCHING_PARTNERS_DOSSIERS = 'FETCHING_PARTNERS_DOSSIERS';